export default {
  route: {
    dashboard: 'Dashboard',
    documentation: 'Documentation',
    pagePermission: 'Page Permission',
    rolePermission: 'Role Permission',
    i18n: 'I18n',
    profile: 'Profile',
    console: 'Console',
    menuMag: 'Menu Management'
  },
  login: {
    smslogin: 'SMS login',
    title: 'Login Form',
    passwordlogin: 'Password login',
    logIn: 'Login',
    username: 'Username',
    password: 'Password',
    forgetpassword: 'Forget password',
    code: 'code',
    codetitles: 'Get code',
    surplus: 'Surplus',
    Recapture: 'Recapture',
    phone: 'Phone number',
    codetitle: 'Please enter the verification code',
    zhuce: 'Account registration',
    create: 'Create Enterprise',
    title1: 'Please enter your mobile number',
    title2: 'Please input a password',
    changepassword: 'Change password',
    confirmpassword: 'Confirm password',
    register: 'Register',
    title3: 'Account already available, return',
    title4: 'Retrieve password',
    ok: 'Ok',
    title5: 'Please enter the correct verification code',
    title6: 'Please enter the correct mobile phone verification code',
    title7: 'Please enter the correct number format',
    title8: 'Please enter a password of at least 8 digits',
    title9: 'Please enter the correct mobile number',
    enterprise: 'Application for Enterprise Opening',
    companyname: 'company name',
    lealperson: 'Leal person',
    address: 'address',
    businesslicense: 'Business license',
    submit: 'Submit',
    rules: 'Please fill in the mobile number or verification code',
    rules1: 'Please fill in the company name',
    rules2: 'Please fill in the legal representative',
    rules3: 'Please fill in the company address',
    rules4: 'Please upload your business license',
    rules5: 'Only one picture can be uploaded',
    rules6: 'Please upload the correct picture format',
    rules7: 'Upload image size cannot exceed 2MB!',
    rules8: 'Confirm whether to jump to the login page',
    rules9: 'The two passwords are inconsistent',
    contactnumber: 'Contact number',
    addresss: 'Address',
    backLogin: 'Back Login'
  },
  documentation: {
    documentation: 'Documentation',
    github: 'Github Repository'
  },
  permission: {
    addRole: 'New Role',
    editPermission: 'Edit',
    roles: 'Your roles',
    switchRoles: 'Switch roles',
    tips: 'In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  guide: {
    description: 'The guide page is useful for some people who entered the project for the first time. You can briefly introduce the features of the project. Demo is based on ',
    button: 'Show Guide'
  },
  layout: {
    addMenu: 'AddMenu',
    allClose: 'Put it all away',
    allOpen: 'Expand all'
  },
  publicjs: {
    title1: 'Delete this file',
    title2: 'This record cannot be restored after deletion. Are you sure you want to delete it'
  },
  public: {
    oks: 'Submitted successfully',
    tips: 'Tips',
    ok: 'OK',
    cancel: 'Cancel',
    upload: 'Upload succeeded',
    check: 'Check',
    establish: 'Establish',
    download: 'Download',
    edit: 'Edit',
    menuedit: 'Permission settings',
    operation: 'Operation',
    remarks: 'Remarks',
    reply: 'Reply',
    delete: 'Delete',
    close: 'Close',
    reset: 'Reset',
    evaluate: 'Evaluate',
    save: 'Save',
    cancelled: 'Cancelled',
    search: 'Search',
    menusettings: 'Menu settings',
    Adddepartment: 'Add sub department',
    searchdepartment: 'Search Department',
    searchusername: 'Search User',
    selectfile: 'Select file',
    down: 'Click to download the template',
    list: 'List of invited persons',
    memberselected: 'Member selected',
    departmentselected: 'Department selected',
    maindepartment: 'Main department',
    setdepartment: 'Set up the main department',
    waring: 'Only members can be selected',
    setsuccessfully: 'Set successfully',
    waring2: 'Only one member can be selected',
    waring3: 'The person has been selected',
    modify: 'Modify',
    disabled: 'Disabled',
    enable: 'Enable',
    add: 'Add',
    enablestatus: 'Enable status',
    display: 'Display',
    tipstext: 'Please enter a name',
    tipstext1: 'Please select file',
    tipstext2: 'Upload succeeded',
    tipstext3: 'Upload file can only be XLS, xlsx format!',
    message00: 'No assessment record',
    message01: 'No statistical chart',
    message02: 'No assessment details',
    message03: 'No assessment plan at present',
    message04: 'No assessment record',
    message05: 'No assessment template',
    message06: 'No employee performance',
    message07: 'No files or folders',
    message08: 'No to-do tasks',
    message09: 'No memorandum',
    message10: 'No income statistics',
    message11: 'No expenditure statistics',
    message12: 'No job description details',
    message13: 'No position system diagram',
    message14: 'No approval record'
  },
  navbar: {
    dashboard: 'Dashboard',
    github: 'Github',
    logOut: 'Log Out',
    profile: 'Profile',
    theme: 'Theme',
    size: 'Global Size',
    console: 'Console',
    tabenterprise: 'Enterprises',
    news: 'News',
    present: 'There is no notice at present'
  },
  toptable: {
    invitationtime: 'Invitation time',
    entrytime: 'Entry time',
    corporatelogo: 'Corporate logo',
    enterprisename: 'Enterprise name',
    state: 'State',
    operation: 'Operation',
    agree: 'Agree',
    refuse: 'Refuse',
    nodata: 'Nothing',
    pending: 'Pending',
    selecttime: 'Select Time',
    startdate: 'Start Date',
    to: 'To',
    endingdate: 'Ending Date',
    all: 'All',
    today: 'Today',
    yesterday: 'Yesterday',
    day7: 'Last 7 days',
    day30: 'Last 30 days',
    thisweek: 'This week',
    lastmonth: 'Last month',
    thismonth: 'Month',
    thisyear: 'Year',
    oneyear: 'One Year',
    name: 'Name',
    department: 'Department',
    worktoday: 'Work today',
    tomorrowplan: "Tomorrow's plan",
    higherevaluation: 'Higher evaluation',
    updatetime: 'Update time',
    gender: 'Gender',
    pleaseselect: 'Please select',
    employeestatus: 'Employee status',
    accountstatus: 'Account status',
    usersearch: 'User search',
    title: 'Name / mobile number / ID',
    phone: 'Mobile number',
    unknown: 'Unknown',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    formal: 'Formal',
    ontrial: 'On trial',
    internship: 'Internship',
    dimission: 'Dimission',
    normal: 'Normal',
    blockup: 'Block up',
    operationtime: 'Operation time',
    behaviorsearch: 'Behavior search',
    behaviortitle: 'Please enter the behavior',
    operationuser: 'Operation user',
    behavior: 'Behavior',
    link: 'Link',
    loginterminal: 'Login terminal',
    operationip: 'Operation IP',
    post: 'Post',
    sort: 'Sort',
    jointime: 'Join time',
    audit: 'Audit',
    names: 'Name',
    assessmentcycle: 'Assessment cycle',
    generationtime: 'Generation time',
    entertime: 'End time of self assessment',
    enttime: 'Evaluation end time',
    numberexaminees: 'Number of examinees',
    assessor: 'Assessor',
    open: 'Open',
    close: 'Close',
    weeklyassessment: 'Weekly assessment',
    monthlyassessment: 'Monthly assessment',
    annualassessment: 'Annual assessment',
    auditstatus: 'Audit status',
    auditstatus1: 'Under review',
    datechoose: 'Time selection',
    departmentchoose: 'Department screening'
  },
  user: {
    apply: {
      invitation: 'Business invitation'
    },
    office: {
      search: 'Click to search for documents',
      see: 'View documents',
      click: 'Click download'
    },
    work: {
      assessment: 'My self assessment',
      evaluate: 'Evaluate subordinates',
      all: 'All',
      backlog: 'Backlog',
      done: 'Done',
      name: 'Name',
      department: 'Department',
      assessmentname: 'Assessment name',
      assessmenttype: 'Assessment type',
      weeklyassessment: 'Weekly assessment',
      monthlyassessment: 'Monthly assessment',
      annualassessment: 'Annual assessment',
      time: 'End time of self assessment',
      endtime: 'End time of superior scoring',
      score: 'Score',
      expired: 'Expired',
      scored: 'Scored',
      qssessmentscore: 'Assessment score',
      assessor: 'Assessor',
      creationtime: 'Creation time',
      dispose: 'Dispose',
      goodmorning: 'Good morning',
      goodafternoon: 'Good afternoon',
      performanceappraisal: 'Performance appraisal',
      mydaily: 'My daily',
      plan: "Today's plan",
      summary: "Today's summary",
      document: 'Enterprise document',
      performanceappraisals: 'Performance appraisal',
      the: 'The',
      week: 'Week',
      month: 'Month',
      subordinatedaily: 'Subordinate daily',
      writedaily: 'Write daily',
      writedailyweek: 'Weekly report',
      writedailymonth: 'Monthly report',
      writecomment: 'Write comment',
      todaywork: "Today's work",
      tomorrowplan: "Tomorrow's plan",
      weekwork: 'Work this week',
      nextweekplan: 'Plan for next week',
      monthwork: 'Work this month',
      nextmonthplan: 'Plan for next month',
      title: "Please fill in today's work",
      tilte1: 'Please fill in the plan for tomorrow',
      title2: 'Please fill in the content',
      title3: 'Delete the member',
      checkdaily: 'Check daily',
      editdaily: 'Edit daily',
      dailyday: 'Daily',
      weekday: 'Weekly',
      monthday: 'Monthly',
      dailytype: 'Report type'
    }
  },
  setting: {
    headportrait: 'Head portrait',
    name: 'Name',
    nickname: 'nickname',
    title: 'Please fill in your name',
    userid: 'User ID',
    useridtitle: 'Please fill in the user ID',
    copy: 'Copy',
    copytitle: 'Copy succeeded',
    phone: 'Mobile number',
    phonetitle: 'Please fill in the mobile number',
    changephone: 'Change mobile phone number',
    mailbox: 'Mailbox',
    selectdepartment: 'Select Department',
    selectadddepartment: 'Select join department',
    invitationlink: 'Invitation link',
    invitationaddlink: 'Generate invitation link',
    invitationcopy: 'Copy link',
    enterprise01: 'Directly join the enterprise',
    enterprise02: 'To be reviewed by the enterprise',
    enterprise03: 'The invitation link is valid for 7 days. After expiration, the link will become invalid and need to be regenerated.',
    enterprise04: ',invite you to join',
    enterprise05: 'Join the team',
    enterprise06: "Don't join temporarily",
    auditsucceeded: 'Audit succeeded',
    auditfailed: 'Audit failed',
    accountfreezing: 'Your account has been frozen',
    enterprise07: 'I got it!',
    mailboxtitle: 'Please fill in the email address',
    box1: 'Invite members',
    box2: 'Batch import members',
    box3: 'Set up your department',
    box4: 'List of Invitees',
    box5: 'A primary department must be set',
    box6: 'Invite to join the enterprise',
    info: {
      essentialinformation: 'Essential information',
      corporatelogo: 'Corporate logo',
      enterpriseabbreviation: 'Enterprise abbreviation',
      enterprisecity: 'Enterprise City',
      businessaddress: 'Business address',
      contactnumber: 'Contact number',
      enterprisemembers: 'Enterprise members',
      members: 'members',
      businesssector: 'Business sector',
      departments: 'departments',
      founder: 'Founder',
      enterpriseid: 'Enterprise ID',
      enterprisestatus: 'Enterprise status',
      deleteenterprise: 'Delete enterprise',
      disabled: 'Disabled',
      normal: 'Normal',
      behalfpayment: 'Behalf Payment',
      expired: 'Expired',
      text: 'Once you delete the enterprise, all projects, departments, members, all content in the project and associated documents within the enterprise will be permanently deleted.This is an unrecoverable operation, please be careful!Once you delete the enterprise, all projects, departments, members, all content in the project and associated documents within the enterprise will be permanently deleted.This is an unrecoverable operation, please be careful!',
      title1: 'Please fill in the company name',
      enterpriseinformation: 'Enterprise information'
    },
    group: {
      text: '1. You can quickly invite members in the organizational structure and set the Department for members;details of members can be found at',
      text2: ' employee files ',
      text3: 'add the set',
      title2: '2. For the selected department, you can add a sub department, modify the name, set the supervisor of the Department, and delete the Department',
      title3: '3. To delete a department, you need to delete its sub departments and members first',
      departmentid: 'Department ID',
      selectdepartment: 'Select Department',
      invitationtype: 'Type',
      lookup: 'Lookup',
      accurate: 'Accurate',
      name: 'Name',
      phone: 'Phone',
      nametitle1: 'Please fill in your name',
      nametitle2: 'Please enter a name',
      memberid: 'ID',
      memtitle: 'Please enter member ID',
      addpersonnel: 'Add personnel',
      batchpersonnel: 'Batch import personnel',
      selectmember: 'Please select a member',
      deletitle: 'Are you sure you want to delete the person',
      deleok: 'Successfully deleted',
      tipsid: 'After filling in the correct member ID number, the user agrees to add it as an enterprise member',
      delemune: 'Are you sure you want to delete this menu',
      editorialdepartment: 'Editorial department',
      adddepartment: 'Add Department',
      deleapply: 'Delete the applicant'
    },
    edit: {
      editorialmembers: 'Editorial members',
      permissionsetting: 'Permission setting',
      membername: 'Member name',
      phone: 'Phone',
      gender: 'Gender',
      unknown: 'Unknown',
      male: 'Male',
      female: 'Female',
      other: 'Other',
      department: 'Department',
      setdepartment: 'Set up the main department',
      zhu: 'main',
      modify: 'Modify',
      position: 'Position',
      identity: 'Identity',
      ordinarymembers: 'Ordinary members',
      executivedirector: 'Executive director',
      text: 'After the identity is set as supervisor, it will automatically have the address book permission of the Department',
      superiordepartment: 'Superior department',
      departmenthead01: 'Department head',
      directsuperior: 'Direct superior',
      administrators: 'Administrators',
      pleaseselect: 'Please select',
      text2: "It can quickly set the administrator's authority identity for members, and ordinary members do not need to be set as administrators",
      selectdepartment: 'Select Department',
      addmembers: 'Add members',
      text3: 'Please set up the main department',
      departmentname: 'Name',
      inputcontent: 'Please input the Department name',
      parentdepartment: 'Parent',
      departmenthead: 'Supervisor',
      selectmembers: 'Select department members',
      departmentintroduction: 'Introduce',
      selectmembers1: 'Select members'
    },
    admin: {
      administratorstatus: 'Administrator status',
      administratorlist: 'Administrator list',
      text1: '1. Set up "Administrator" for personnel with cross department management needs in the enterprise',
      text2: '2. Delete member here only delete the administrator role of the member',
      text3: '3. An enterprise member can set multiple administrator roles',
      selectmembers: 'Select members',
      deletetitle: 'Remove administrator identity',
      deletetitle2: 'Delete the member',
      deletetitle3: 'Only one member can be selected',
      deletetitle4: 'Only one member can be selected',
      deletetitle5: "You can't choose yourself",
      Editoradministrator: 'Editor administrator identity',
      identityname: 'Identity name',
      addresspermissions: 'Permissions',
      selectdepartment: 'Select Department'
    }
  },
  hr: {
    text1: '1. After the appraisal scheme is created, the performance appraisal will be automatically generated and the appraisee will be notified according to the appraisal cycle',
    text2: '2. When the appraisee is in multiple appraisal schemes, the latest updated appraisal scheme is pushed for him. In each cycle, one appraisee can only fill in one appraisal form',
    text3: '3. when the employee status is changed to "resignation", or the account status is changed to "disabled", the appraisal form will not be pushed for him or her',
    text4: '1. Employee file and member data of organization structure are synchronized. Only employee information with normal account number is displayed in organization structure',
    text5: 'Employee file',
    text6: 'addition settings',
    text7: '2. The employee whose account number is disabled does not occupy the available quota of the enterprise',
    text8: '3. When the employee\'s status is changed to "resignation", the account status will be automatically changed to "disabled"; Manually set the "disabled" account, you need to manually activate it again before you can use it, which is not affected by the change of "employee status"',
    assessmentscheme: 'Add assessment scheme',
    deletetext1: 'Delete the appraisal scheme',
    assessmentname: 'Assessment name',
    inputplaceholder1: 'Please input assessment name',
    inputplaceholder2: 'Please select assessment cycle',
    inputplaceholder3: 'Please select assessment document',
    inputplaceholder4: 'Please select the appraisal generation time',
    inputplaceholder5: 'Please select the assessment time',
    inputplaceholder6: 'Please select the end time of self-assessment',
    inputplaceholder7: 'Please select the end time of superior scoring',
    inputplaceholder8: 'Only letters can be entered',
    inputplaceholder9: 'Only numbers can be entered',
    assessmentdocument: 'Assessment document',
    documentset: 'Document settings',
    assessmentstatus: 'Assessment status',
    enttime: 'End time of self assessment',
    enttimescoring: 'End time of superior scoring',
    selectmembers: 'Select members',
    rules: 'Please input assessment name',
    rules1: 'Please select assessor',
    rules2: 'Please select the examinee',
    rules3: 'Please select assessment document',
    rules4: 'Please select appraisal document settings',
    rules5: 'Please select generation time',
    rules6: 'Please select the end time of self-assessment',
    rules7: 'Please select the end time of superior scoring',
    rules8: 'Only one assessor can be added',
    weeklyassessment: 'Weekly assessment',
    monthlyassessment: 'Monthly assessment',
    annualassessment: 'Annual assessment',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    month: 'Month',
    nextmonth: 'Nextmonth',
    year: 'Year',
    nextyear: 'Nextyear',
    name: 'Name',
    nametext: 'Please fill in the name',
    abscissa: 'Absciss',
    abscissatexte: 'Please enter the abscissa, only letters can be filled in',
    abscissatext: 'Only letters can be entered',
    ordinate: 'Ordinate',
    ordinatetexte: 'Please input ordinate, only numbers',
    ordinatext: 'Only numbers can be entered',
    positionstatus: 'Position status',
    dimission: 'Dimission',
    onob: 'On the job',
    deletetitle: 'Delete the experience',
    placeholder: 'Please fill in the name of the employee',
    placeholder1: 'Please fill in the mobile number',
    placeholder2: 'Please fill in the ID card number',
    placeholder3: 'Please select gender',
    placeholder4: 'Select a date',
    placeholder5: 'Please choose a nationality',
    placeholder6: 'Please fill in the political outlook',
    placeholder7: 'Please fill in the education background',
    placeholder8: 'Please fill in the degree',
    placeholder9: 'Please fill in your native place',
    placeholder10: 'Please fill in the residence address',
    placeholder11: 'Please select',
    placeholder12: 'Please fill in the emergency contact',
    placeholder13: 'Please fill in the emergency number',
    placeholder14: 'Please fill in the email',
    placeholder15: 'Please fill in the sort',
    placeholder16: 'Please fill in the position',
    placeholder17: 'Please select administrator',
    placeholder18: 'Please set up the main department',
    placeholder19: 'Please select employee status',
    employeename: 'Employee name',
    phonenumber: 'Phone number',
    idnumber: 'ID number',
    gender: 'Gender',
    unknown: 'Unknown',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    datebirth: 'Date of birth',
    age: 'Age',
    nation: 'Nation',
    politicaloutlook: 'Political outlook',
    highesteducation: 'Highest education',
    highestdegree: 'Highest degree',
    nativeplace: 'Native place',
    currentresidence: 'Current residence',
    maritalstatus: 'Marital status',
    unmarried: 'Unmarried',
    married: 'Married',
    workinghours: 'Working hours',
    emergencycontact: 'emergency contact',
    emergencycontactnumber: 'Emergency contact number',
    contactemail: 'Contact email',
    sort: 'Sort',
    accountstatus: 'Account status',
    education: 'education',
    normal: 'Normal',
    blockup: 'Block up',
    tipstetx: 'After the account is disabled, employees will not be able to log in to the enterprise background',
    formal: 'Formal',
    ontrial: 'On trial',
    internship: 'Internship',
    tablist1: 'Personal information',
    tablist2: 'Employee information',
    tablist3: 'Personal experience',
    tablist4: 'pay for performance',
    employeestatus: 'Employee status',
    entrytime: 'Entry time',
    department: 'Department',
    setup: 'Set up main department',
    zhu: '(main)',
    position: 'Position',
    administrators: 'Administrators',
    trialtime: 'Trial time',
    positivetime: 'Positive time',
    timeexpiration: 'Time of expiration',
    workingexperience: 'Working experience',
    addexperience: 'Add experience',
    workexperience: 'Work experience',
    educationalexperience: 'Educational experience',
    company: 'Company',
    jobdescription: 'Job description',
    reasonsleaving: 'Reasons for leaving',
    admissiontime: 'Admission time',
    graduationtime: 'Graduation time',
    schoolname: 'School name',
    major: 'Major',
    date: 'Date',
    degree: 'Gegree',
    selectdepartment: 'Select Department',
    documentsearch: 'Document search',
    newdocument: 'New document',
    importdocuments: 'Import documents',
    searchdocuments: 'Search for documents',
    searchcategories: 'Search categories',
    addcategory: 'Add category',
    deletetitle1: 'Are you sure you want to delete this menu',
    documentcover: 'Document cover',
    filename: 'File name',
    founder: 'Founder',
    template: 'Template',
    astemplate: 'As a template',
    nottemplate: 'Not a template',
    state: 'State',
    display: 'Display',
    hide: 'Hide',
    updatetime: 'Update time',
    download: 'Download',
    editdocument: 'Edit document',
    sharelist: 'Share list',
    addpermission: 'Add permission',
    deletetitle2: 'Are you sure you want to delete this document',
    deleteok: 'Successfully deleted',
    more: 'More',
    documentname: 'Document name',
    placeholder20: 'Fill in the name of the document',
    documenttype: 'Document type',
    placeholder21: 'Select document type',
    documentcovers: 'Document cover',
    placeholder22: 'Upload document cover',
    open: 'Open',
    close: 'Close',
    placeholder23: 'Please upload the correct image format',
    uploadfile: 'Upload file',
    Partnotuploaded: 'Part not uploaded',
    uploadcomplete: 'Upload complete',
    clickview: 'Click to view',
    importlist: 'Import list',
    documentformat: 'Document format',
    documentsize: 'Document size',
    success: 'Success',
    fail: 'Fail',
    placeholder24: 'Please upload the file',
    names: 'Name',
    sharepeoplelist: 'Share people list',
    modifyandview: 'Modify and view',
    viewonly: 'View only',
    deletetitle3: 'Delete the person',
    selectuser: 'Select user',
    adduser: 'Please add user',
    addagain: 'Add again',
    type: 'Type',
    jobsearch: 'Job search',
    placeholder25: 'Please input the content',
    addposition: 'Add position',
    viewpositionmap: 'View position map',
    jobtitle: 'Job title',
    immediatesuperior: 'Immediate superior',
    toplevel: 'top-level',
    numberPosts: 'Number of Posts',
    jobdescriptions: 'Job description',
    joboetails: 'Job details',
    creationtime: 'Creation time',
    jobresponsibilities: 'Job responsibilities',
    message: 'Please fill in the post name',
    message1: 'Please enter a name',
    message2: 'Please enter job description',
    message3: 'Delete the position',
    message4: 'Please select superior position',
    message5: 'Please select position level',
    message6: 'Are you sure you want to delete this category',
    message7: 'Are you sure you want to delete this type',
    jobdescriptiones: 'Job description',
    postsupervisor: 'Post Supervisor',
    higherposition: 'higher position',
    editorialpost: 'Editorial post',
    addcategorys: 'Add category',
    rankcategoryname: 'Rank category name',
    ranknumber: 'Rank number',
    prerankcategories: 'Pre-rank categories',
    addtype: 'Add type',
    addrank: 'Add rank',
    rankname: 'Rank name',
    numberranks: 'Number of ranks',
    prerankrequirements: 'Pre-rank requirements',
    positionlevel: 'Position level',
    ranktype: 'Rank alias',
    rank: 'Rank',
    message8: 'Please select a job level alias',
    message9: 'Please select a job level',
    ranktypes: 'Rank category'
  },
  finance: {
    entrytime: 'Time of payment',
    accounttype: 'Bookkeeping type',
    pleaseselect: 'Please select',
    pleaseinput: 'Please input',
    accountinputdate: 'Select a date:',
    accountselectdate: 'Please select a date',
    paytype: 'Payment method',
    all: 'all',
    income: 'income',
    pay: 'pay',
    accountname: 'Account name',
    addposition: 'New accounts',
    addpositionTitle: 'New account',
    accounttabtitle: 'Account type',
    accounttabtype: 'Account type',
    accountnumber: 'Account amount',
    pleasenumber: 'Please input the account amount:',
    accounttabremark: 'Remarks',
    pleaseremark: 'Please enter the remark information',
    accounttabmoney: 'Amount of money',
    accountpay: 'Payment method',
    keeptype: 'Bookkeeping type',
    keepitem: 'Bookkeeping classification',
    addpositionType: 'New category',
    message3: 'Are you sure you want to delete the fund classification',
    message4: 'Are you sure you want to delete the fund record',
    pleaseinput1: 'Please enter account classification',
    businesstrends: 'Business trends',
    incometrends: 'Analysis of income proportion',
    expendtrends: 'Analysis of expenditure proportion',
    switchstyles: 'Switch styles',
    noselect: 'Not selected',
    mode: 'Revenue and expenditure approach',
    batchupload: 'Batch upload',
    batchexport: 'Batch export',
    exporttemplate: 'Export upload template',
    serialnumber: 'Serial number',
    type: 'Type',
    amountmoney: 'Amount of money',
    proportion: 'Proportion',
    other: 'Other',
    revenueamount: 'Revenue amount',
    expenditureamount: 'Expenditure amount',
    totalrevenue: 'Total revenue',
    totalexpenditure: 'Total expenditure',
    sourceincome: 'Source of income',
    sourceexpenditure: 'Expenditure destination',
    one: 'One',
    two: 'Two',
    three: 'Three'
  },
  access: {
    selectexaminee: 'Select appraisee',
    selecteassessmenttype: 'Select appraisal type',
    adddimension: 'Add appraisal dimension',
    addtarget: 'Apply the assessment template',
    targetname: 'Indicator name',
    placeholder01: 'Enter indicator name',
    targetexplain: 'Indicator description',
    placeholder02: 'Input Specifications',
    addTarget01: 'Select index library',
    addTarget02: 'Add indicators',
    weight: 'The weight',
    selecttemplate: 'Select a template',
    settemplate: 'Set the template',
    edittemplate: 'Edit the template',
    savedraft: 'Save drafts',
    saveandsubmit: 'Save',
    dimensionname: 'Dimension names',
    dimensionweight: 'The dimension weight',
    dimensionscore: 'Dimension score',
    targetibrary: 'Indicator Template Library',
    appraisallibrary: 'Assessment Template library',
    templatename: 'Template name',
    templatecontent: 'Content of the template',
    templatetype: 'Classification of the template',
    selecttemplatetype: 'Select template categories',
    openassessmenttype: 'Please turn on the assessment type',
    placeholder03: 'The check dimension name is empty',
    placeholder04: 'The weight of the assessment dimension is empty',
    placeholder05: 'The evaluation template name is empty',
    placeholder06: 'The assessment template is empty',
    placeholder07: 'Select a template category',
    placeholder09: 'Fill in indicator name',
    placeholder10: 'Fill in indicator content',
    placeholder11: 'Fill in index weight',
    placeholder12: 'The assessment dimension cannot be empty',
    placeholder13: 'The assessment dimension weight must be 100',
    placeholder14: 'The assessment type cannot be empty',
    placeholder15: 'Assessment time should not be empty',
    scoreshows: 'Score shows',
    scoretype: 'Scoring method',
    scoretype1: 'Add and score',
    scoretype2: 'Weighted score',
    placeholder16: 'Please enter the content',
    classname: 'Class name',
    fractionalrange: 'Fractional range',
    levelthat: 'Level that',
    score: 'score',
    employees: 'Employees',
    newemployees: 'New employee',
    resignedemployees: 'Resigned employee',
    inputthescore: 'Input the score',
    placeholder17: 'The input level',
    addarating: 'Add a rating',
    tips01: 'Are you sure you want to delete this record',
    tips02: 'The score interval value cannot be empty',
    tips03: 'The score range cannot be less than or equal to the minimum',
    tips04: 'The level name cannot be empty',
    tips05: 'The level description cannot be empty',
    openstatus: 'On state',
    goalsettingtime: 'Goal setting time',
    numberofdays: 'Please enter number of days',
    day: 'day',
    superiorevaluationtime: 'Superior evaluation time',
    performancereviewtime: 'Performance review time',
    assessee: 'Assessee',
    beforetheexamination: 'Before the examination',
    aftertheexaminationbegins: 'After the examination begins',
    beforetheendofassessment: 'Before the end of assessment',
    aftertheexamination: 'After the examination',
    superiorevaluation: 'After the superior evaluation',
    tips06: 'Please fill in the name',
    tips07: 'Please fill in the target customization days',
    tips08: 'Please fill in the superior evaluation days',
    tips09: 'Please fill in the number of superior audit days',
    theinspectionplan: 'The inspection plan',
    evaluationscore: 'Evaluation score',
    assessmentprocess: 'The assessment process',
    tips10: 'Please add content',
    completion: 'Completion (Self evaluation)',
    completion1: 'Self scoring (Self evaluation)',
    higherevaluation: 'The higher evaluation',
    degree: 'To complete the degree (Self evaluation)',
    inputcompletion: 'Input completion',
    superiorgrade: 'The superior grade',
    hiddennote: 'Hidden note',
    myremark: 'My remark',
    tips11: 'After submitting and saving, it cannot be modified. Are you sure you want to submit for assessment',
    tips12: 'Fill in the assessment remarks, this information is only visible to yourself',
    totalscore: 'Total score',
    totalscore1: 'Current score',
    rejectcomplaint: 'To reject the complaint',
    percomplaint: 'Performance of the complaint',
    tips13: 'Please enter a reason for rejection',
    tips14: 'Please enter reasons for appeal',
    dealwith: 'Have to deal with',
    hasbeenrejected: 'Has been rejected',
    processing: 'In the processing',
    toscore: 'To score',
    tips15: 'If no appraisee is selected, all employees will participate by default',
    createassessment: 'Create assessment',
    assessmentgrade: 'Assessment grade',
    enabled: 'Enabled',
    notenabled: 'Not enabled',
    starttime: 'Assessment start time',
    endtime: 'Assessment end time',
    scoringrecord: 'Scoring record',
    tips16: 'After enabling, appraisal content cannot be modified. Are you sure you want to submit',
    agencymatters: 'Agency matters',
    examinee: 'Examinee',
    placeholder18: 'Please select the appraisee',
    placeholder19: 'Please select appraisal status',
    currentassessment: 'Current assessment',
    selfassessment: 'My self-assessment',
    selfassessment01: 'My assessment',
    subordinateassessment: 'Subordinate assessment',
    performancereview: 'Performance review',
    mydepartment: 'My department',
    selectpersonnel: 'Select personnel',
    goalsetting: 'Goal setting',
    executionphase: 'execution phase',
    performancegrievance: 'Performance grievance',
    end: 'End',
    directsuperior: 'Direct superior',
    reviewer: 'Reviewer',
    supervisor: 'Supervisor',
    placeholder20: 'The direct superior is the direct superior of the appraiser. When there are more than one designated person, the approval or rejection of one person becomes effective',
    participants: 'Participants',
    applicant: 'Applicant',
    required: 'Required',
    jurisdiction: 'Jurisdiction',
    adjustscore: 'Adjust score',
    assessmentscore: 'Assessment score',
    superiorcomments: 'Superior comments',
    placeholder21: 'At least one person must be specified',
    placeholder22: 'Select executor',
    assessemployees: 'Assess employees',
    assessmentstatistics: 'Assessment statistics',
    deleterecord: 'Delete record',
    return: 'Return',
    start: 'Start',
    placeholder23: 'Select appraiser',
    assessmenttime: 'Assessment time',
    ren: ' People',
    ci: ' Second',
    assessmentdetails: 'Assessment details',
    deletereason: 'Delete reason',
    deleteperson: 'Delete person',
    placeholder24: 'There is no content to export',
    performanceexport: 'Performance export'
  },
  file: {
    placeholder01: 'Search file name',
    commonfiles: 'Common files',
    enterprisespace: 'Enterprise space',
    lately: 'Lately',
    collection: 'Collection',
    share: 'Share',
    myfiles: 'My files',
    commonfolders: 'Common folders',
    recyclebin: 'Recycle bin',
    spacesettings: 'Space settings',
    spatialediting: 'Space editing',
    placeholder02: 'Are you sure you want to delete this space',
    spacename: 'Space name',
    placeholder03: 'Enter a space name',
    addmember: 'Add member',
    spacemember: 'Space member',
    batchsettings: 'Batch settings',
    placeholder04: 'Please add sharing members',
    moveto: 'Move to',
    shareme: 'Share it with me',
    myshare: 'My share',
    newlybuild: 'Newly build',
    upload: 'Upload',
    restorefile: 'Restore file',
    completelydelete: 'Completely delete',
    returnspace: 'Return to enterprise space',
    filename: 'File name',
    updatetime: 'Update time',
    creationtime: 'Creation time',
    filesize: 'File size',
    deletetime: 'Delete time',
    order: 'ASC',
    desc: 'DESC',
    type: 'Type',
    document: 'Document',
    ppt: 'PPT',
    picture: 'Image',
    table: 'XLSX',
    newdocument: 'new Document',
    newtable: 'New XLSX',
    newslide: 'New PPT',
    documenttemplates: 'Using document templates',
    newfolder: 'New folder',
    selecttemplate: 'Select template',
    allfiles: 'All files',
    placeholder05: 'Please select the content to delete',
    placeholder06: 'Please select the content to restore',
    placeholder07: 'Please select the content to move',
    detailedinformation: 'Detailed information',
    filetype: 'File type',
    folder: 'Folder',
    filelocation: 'File location',
    allpositions: 'All positions',
    modificationtime: 'Modification time',
    reverse: 'Reverse',
    all: 'All',
    total: 'total',
    individual: 'Individual',
    setcommon: 'Set as common',
    cancelcommon: 'Cancel common',
    cancelcollection: 'Cancel collection',
    placeholder08: 'Search file templates',
    filesharing: 'File sharing',
    addsharedmembers: 'Add shared members',
    selectsharer: 'Select sharer',
    placeholder09: 'Are you sure you want to cancel sharing',
    placeholder10: 'Please enter a file name',
    myauthority: 'My permissions',
    sharer: 'Sharer',
    editable: 'Editable',
    readonly: 'Read-only',
    people: 'People',
    sharingsettings: 'Sharing settings',
    cancelsharing: 'Cancel sharing',
    copyto: 'Copy to',
    rename: 'rename',
    attribute: 'Attribute',
    fileattribute: 'File attribute',
    usetemplate: 'Use template',
    placeholder11: 'Search file templates',
    placeholder12: 'Please select the content to use template',
    directory: 'Directory authorization',
    setdirectory: 'Set directory authorization'
  },
  customer: {
    addtype: 'Add category',
    edittype: 'Edit classification',
    typename: 'Classification name',
    labelname: 'Label name',
    message01: 'Are you sure you want to delete this category',
    addlabel: 'Add label group',
    editlabel: 'Edit label group',
    labelename: 'Label group name',
    label: 'Label',
    setlabel: 'Set label',
    transfer: 'transfer',
    invoicerange: 'Invoice range:',
    invoicesearch: 'Invoice search:',
    invoiceapply: 'Apply for invoice',
    invoiceedit: 'Invoice editing',
    placeholder01: 'Please enter invoice name / customer name / contract name',
    placeholder02: 'Select invoice range',
    placeholder03: 'Please enter classification name',
    placeholder04: 'Please enter sorting',
    placeholder05: 'Please enter label name',
    contractname: 'Contract name',
    contractstatus: 'Contract status',
    execution: 'In execution',
    abnormal: 'abnormal',
    finished: 'Finished',
    enddate: 'Contract end date',
    startdate: 'Contract start date',
    notstarted: 'Not started',
    invoicname: 'Invoice name',
    contractpay: 'Contract amount',
    invoicingpay: 'Invoice amount',
    invoicingdate: 'Billing date',
    invoicingtype: 'Billing type',
    accessstatus: 'Audit status',
    actualdate: 'Actual Invoicing Date',
    salesman: 'Salesman',
    creationtime: 'Creation time',
    message02: 'Category name cannot be empty',
    message03: 'Category name cannot be empty. Are you sure you want to delete this tag group',
    message04: 'Are you sure you want to delete this tag',
    customersource: 'Customer source',
    renewaltype: 'Renewal type',
    addmodel: 'Add type',
    placeholder06: 'Please enter the type',
    message05: 'Name cannot be empty',
    placeholder07: 'Please enter customer name',
    placeholder08: 'Please select customer source',
    placeholder09: 'Please enter your mobile phone number',
    placeholder10: 'Please enter email address',
    placeholder11: 'Please select a customer label',
    placeholder12: 'Please select a customer category',
    placeholder13: 'Please enter detailed address',
    placeholder14: 'Please enter contact name',
    placeholder15: 'Please enter the phone number of the contact',
    placeholder16: 'Please enter the email address of the contact',
    placeholder17: 'Please enter position',
    placeholder18: 'Please fill in the remarks',
    placeholder19: 'Please select a city',
    customername: 'Customer name',
    customeremail: 'mailbox',
    customerlabel: 'Customer label',
    customertype: 'Customer classification',
    areas: 'Provincial and urban areas',
    detailedaddress: 'Detailed address',
    contactinfo: 'contact information',
    contactname: 'Contact name',
    position: 'Position',
    selectlabel: 'Select label',
    addcustomer: 'Add customer',
    modify1: 'Modify transaction status',
    modify2: 'Modify transaction status',
    nodeal: 'No deal',
    closed: 'Closed',
    myclient: 'My client',
    lowerlevel: 'My subordinate client',
    placeholder20: 'Please select a customer range',
    placeholder21: 'Please enter customer name / mobile number',
    customerscope: 'Customer scope',
    customersearch: 'Customer search',
    addliaison: 'Add a Contact',
    editliaison: 'Edit Contact',
    message06: 'Are you sure you want to delete the changed customer',
    message07: 'Are you sure you want to delete this contact',
    addcontract: 'Add contract',
    placeholder22: 'Please select content',
    batchtransfersettings: 'Batch transfer settings',
    transfersettings: 'Transfer settings',
    placeholder23: 'Are you sure you want to delete this record',
    audit: 'Audit',
    passed: 'Passed',
    fail: 'Fail',
    remarkinformation: 'Remark information',
    reason: 'Reason',
    placeholder24: 'The financial department has not issued an invoice yet',
    notinvoiced: 'Not invoiced',
    invoiced: 'Invoiced',
    placeholder25: 'Please select a member to transfer',
    customertransfer: 'Customer transfer',
    contracttransfer: 'Contract transfer',
    invoicetransfer: 'Invoice transfer',
    unpaid: 'Unpaid',
    uncleared: 'Uncleared',
    settled: 'Settled',
    urgentrenewal: 'Urgent renewal',
    overdue: 'Overdue',
    Renewalfee: 'Renewal fee',
    norenewal: 'No renewal',
    contractsettlement: 'Payment status',
    contractrenewal: 'Contract renewal',
    contractscope: 'Contract scope',
    contractsearch: 'Contract search',
    placeholder26: 'Please enter the contract name',
    placeholder27: 'Are you sure you want to delete this contract',
    placeholder28: 'Please enter the contract amount',
    placeholder29: 'Please select a start time',
    placeholder30: 'Please select an end time',
    placeholder31: 'Please select renewal type',
    placeholder32: 'Please enter the renewal period',
    placeholder33: 'Please enter the renewal period',
    placeholder34: 'Please select the collection date',
    placeholder35: 'Please enter the renewal amount',
    placeholder36: 'Please select a renewal date',
    placeholder37: 'Please enter the estimated collection amount',
    placeholder38: 'Please select the collection reminder time',
    placeholder39: 'Please select renewal reminder time',
    placeholder40: 'Please enter the reminder content',
    placeholder41: 'Please select a reminder date',
    money: 'Amount',
    starttime: 'Contract start time',
    endtime: 'Contract end time',
    amountreceived: 'Amount received',
    paymentstatus: 'Payment status',
    follow: 'Follow',
    personalinvoice: 'Personal ordinary invoice',
    enterpriseinvoice: 'Enterprise ordinary invoice',
    specialinvoice: 'Enterprise special invoice',
    collectionrecord: 'Collection record',
    collectiondate: 'Collection date',
    collectionamount: 'Collection amount',
    collectionamount01: 'Estimated collection amount',
    addcollection: 'Add collection',
    editcollection: 'Edit collection',
    addrenewal: 'Add renewal',
    editrenewal: 'Edit renewal',
    renewaldate: 'Renewal date',
    renewaldate01: 'Renewal reminder date',
    renewalamount: 'Renewal amount',
    renewalrecord: 'Renewal record',
    renewalperiod: 'Renewal period',
    collectiondate01: 'Collection reminder date',
    remindercontent: 'Reminder content',
    reminderdata: 'Reminder time',
    placeholder42: 'Please enter invoice name',
    placeholder43: 'Please fill in the name of the contract',
    placeholder44: 'Please enter Invoicing amount',
    placeholder45: 'Please select invoice type',
    placeholder46: 'Please enter header information',
    placeholder47: 'Please enter taxpayer identification number',
    placeholder48: 'Please enter the Bank of deposit',
    placeholder49: 'Please enter account number',
    placeholder50: 'Please enter billing address',
    placeholder51: 'Please enter the phone number',
    placeholder52: 'Please enter contact',
    placeholder53: 'Please enter the contact number',
    placeholder54: 'Please select the mailing method',
    placeholder55: 'Please enter email address',
    placeholder56: 'Please enter the mailing address',
    placeholder57: 'Last follow-up time',
    invoiceinformation: 'Invoice information',
    headerinformation: 'Invoice type',
    invoiceheader: 'Invoice header',
    paytaxes: 'Taxpayer identification number',
    bankdeposit: 'Bank of deposit',
    accountnumber: 'Account number',
    billingaddress: 'Billing address',
    tel: 'Telephone',
    mailinginformation: 'Mailing information',
    contacts: 'contacts',
    contactnumber: 'contact telephone',
    mailingtype: 'Mailbox mode',
    emailaddress: 'Email address',
    mailingaddress: 'Mailing address',
    express: 'express',
    mail: 'mail',
    billinginformation: 'Billing information',
    invoicingstatu: 'Invoicing status',
    billingdocuments: 'Billing documents',
    transactionstatus: 'Transaction status',
    batchsetlabel: 'Batch set label',
    placeholder58: 'The selected label cannot be empty',
    placeholder59: 'Fill in follow-up information',
    placeholder60: 'Please enter the reminder content',
    placeholder61: 'Add follow up reminder',
    placeholder62: 'Edit follow-up reminder',
    placeholder63: 'Are you sure you want to delete this follow-up record',
    addfile: 'Add file',
    filename: 'File name',
    uploaduser: 'Upload user',
    uploaddate: 'Upload time',
    followrecord: 'Follow up record',
    contract: 'Contract',
    paymentrecord: 'Payment record',
    paymentreminder: 'Payment reminder',
    invoice: 'Invoice',
    annexrelated: 'Annex related',
    annexrelated12: 'Are you sure you want to delete this attachment',
    placeholder64: 'Please select the contract scope',
    businesstype: 'Business type',
    businesscontent: 'Business content',
    namesearch: 'Name search',
    Contractpayment: 'Contract payment collection',
    applytime: 'Application time',
    relatedcontract: 'Related contract',
    invoicing: 'Invoicing',
    examine: 'Examine',
    dutyparagraph: 'Duty paragraph',
    invoicereview: 'Invoice review',
    placeholder65: 'Please select billing time',
    placeholder66: 'Please enter the contract number',
    contractno: 'Contract No',
    fundaudit: 'Fund audit',
    invoicingapproval: 'Invoicing approval',
    customer: 'Customer',
    labelfiltering: 'Label filtering',
    placeholder67: 'Approved content cannot be deleted',
    sendmail: 'Send mail',
    yes: 'Yes',
    no: 'No',
    placeholder68: 'Mailbox cannot be empty',
    placeholder69: 'Please enter the correct email format',
    placeholder70: 'Illegal mobile phone number input',
    viewcustomer: 'View customer',
    placeholder71: "The customer's phone number is illegal",
    placeholder72: 'Illegal customer email',
    placeholder73: 'The contact phone number is illegal',
    placeholder74: 'Illegal contact email',
    placeholder75: 'Please enter the search content',
    placeholder76: 'Press enter to complete the entry',
    collectionreminder: 'Collection reminder',
    addcollectionreminder: 'Add collection reminder',
    editcollectionreminder: 'Edit collection reminder',
    collectionremindertime: 'Collection reminder time',
    renewalreminder: 'Renewal reminder',
    renewalremindertime: 'Renewal reminder time',
    addrenewalreminder: 'Add renewal reminder',
    editrenewalreminder: 'Edit renewal reminder',
    placeholder77: 'Are you sure you want to delete this reminder',
    placeholder78: 'Are you sure you want to delete invoice (to be approved) records in batch',
    datechoose: 'TimePicker',
    departmentchoose: 'Department of screening',
    totalincome: 'Total income of September (Yuan)',
    newcustomer: 'New customers (person)',
    newcontract: 'New Contract (one)',
    newamount: 'New contract amount (Yuan)',
    uncollectedamount: 'Outstanding amount (Yuan)',
    departmentperformance: 'Department performance analysis and statistics',
    contracttype: 'Analysis and statistics of contract types',
    salestop: 'Sales performance ranking',
    ranking: 'Ranking',
    completeproportion: 'Complete the proportion',
    completeamount: 'To complete the amount',
    totalcontractamount: 'Total Contract amount (Yuan)'
  },
  calendar: {
    placeholder01: 'Search memo',
    placeholder02: 'Fill in the memo title',
    placeholder03: 'Memorandum title',
    placeholder04: 'Memorandum content',
    placeholder05: 'The title of the memo cannot be empty',
    placeholder06: 'The content of the memo cannot be empty',
    placeholder07: 'Are you sure you want to delete this memo',
    placeholder08: 'Are you sure you want to delete the category',
    addtype: 'Add subcategory',
    memorandum: 'memorandum',
    scheduleview: 'Schedule view',
    newschedule: 'New schedule',
    editchedule: 'Edit schedule',
    addtask: 'Add task',
    edittask: 'Edit task',
    checktask: 'View task',
    todocontent: 'Todo content',
    remarks: 'Remarks',
    repeatreminder: 'Repeat reminder',
    placeholder09: 'Fill in the to-do list',
    placeholder10: 'Please select a reminder method',
    placeholder11: 'Select reminder time',
    placeholder12: 'To do content cannot be empty',
    placeholder13: 'Reminder time cannot be empty',
    placeholder14: 'Please select an end date',
    placeholder15: 'Please select a repeating week',
    placeholder16: 'Please select a duplicate day',
    norepetition: 'No repetition',
    repeatbyday: 'Repeat by day',
    repeatweekly: 'Repeat weekly',
    repeatmonthly: 'Repeat monthly',
    repeatyear: 'Repeat year by year',
    custom: 'Custom',
    customrepeat: 'Custom repeat',
    repetitiontype: 'Repetition type',
    frequency: 'Frequency',
    weekly: 'Weekly',
    monthly: 'Monthly',
    enddate: 'End date',
    neverend: 'Never end',
    year: 'Year',
    placeholder17: 'Please enter reminder frequency',
    newmemo: 'New memo',
    newtodo: 'New to do',
    edittodo: 'Edit to do'
  },
  business: {
    addBusiness: 'Add business',
    businessPic: 'Approval process Icon',
    businessType: 'Approval type',
    businessType1: 'Approval type：',
    businessPic1: 'Approval process Icon：',
    Range: 'Sponsor scope',
    submissionTime: 'Submission time',
    approvalStatus: 'Approval status',
    agan: 'Resubmit after approval is rejected',
    basicConfiguration: 'Basic configuration',
    formConfiguration: 'Form configuration',
    processSetting: 'Process configuration',
    ruleConfiguration: 'Rule configuration',
    businessTypeIn: 'Approval type description',
    handle: 'exception handling',
    handle1: 'Automatic consent',
    handle2: 'Transfer to designated personnel',
    automatic: 'Automatic approval',
    automatic1: 'When the same approver repeatedly approves the same document',
    automatic2: 'Only the first node needs to be approved, and the rest are automatically agreed',
    automatic3: 'Automatic consent only in case of continuous approval',
    automatic4: 'Each node needs approval',
    editAuthority: 'Modify permissions',
    editAuthority1: 'When submitting an application, an employee cannot modify the fixed person',
    editAuthority2: 'When submitting an application, the employee cannot delete the fixed CC',
    revokeAuthority: 'Revoke permission',
    revokeAuthority1: 'Allow revocation after passing',
    revokeAuthority2: 'After approval, it can be revoked with the consent of the approver',
    refuseAuthority: 'Approval rejected',
    refuseAuthority1: 'Return to the initial level of the approval process, and all approvers need to re approve',
    refuseAuthority2: 'Skip the approval process passed level and return to the rejected level',
    changeIcon: 'Select Icon',
    release: 'release',
    return: 'return',
    message01: 'Are you sure you want to delete this approval process',
    approval: 'Office approval',
    message1: 'Please enter approval type',
    message2: 'Please select the template Icon',
    message3: 'Please enter the approval type description'
  }
};